export enum DeviceOPEEnum {
  GetDevice = 'getDevice',
  PutDevice = 'putDevice',
  DelDevice = 'delDevice',
  GetDevices = 'getDevices',
  GetDevicesMetricInstances = 'getDevicesMetricInstances',
  ResetDeviceFromModel = 'resetDeviceFromModel',

}
